import "./styles.css";
const awards = document.querySelector(".awards");
if (awards) {
    document.addEventListener("DOMContentLoaded", () => {
        // Get DOM elements
        const viewedPrizesContainer = document.getElementById("viewed-prizes");
        const upcomingPrizesContainer = document.getElementById("upcoming-prizes");
        const prevButton = document.getElementById("prev-button");
        const nextButton = document.getElementById("next-button");
        const prizeTitle = document.getElementById("prize-title");
        const prizeType = document.getElementById("prize-type");
        const prizeDescription = document.getElementById("prize-description");
        // Get all prize items
        const prizeItems = document.querySelectorAll(".prize-item");
        const totalPrizes = prizeItems.length;
        let currentIndex = 0;
        // Criar os elementos SVG para os botões caso os arquivos não estejam disponíveis
        if (prevButton && !prevButton.querySelector("img")?.complete) {
            prevButton.innerHTML = '<div class="arrow arrow-left"></div>';
        }
        if (nextButton && !nextButton.querySelector("img")?.complete) {
            nextButton.innerHTML = '<div class="arrow arrow-right"></div>';
        }
        // Prize data
        const prizeData = [
            {
                title: "Echo Dot* <br/>com Alexa",
                typeId: 1,
                type: "Cupom raspável",
                description: '<span class="description-intro">Abasteceu, raspou, ganhou… e agora é só dizer: </span>' +
                    '<span class="description-highlight">"Alexa, me lembra de abastecer novamente com Shell V-Power Etanol!". </span>' +
                    '<span class="description-outro">Praticidade e tecnologia chegam com o seu prêmio.</span>',
            },
            {
                title: "Honda Pop<br>110i ES**",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Chegou a hora de acelerar. Com a Honda Pop 110i ES**, mobilidade e economia entram no seu caminho com estilo. Um prêmio que te leva longe.</span>',
            },
            {
                title: "iPhone 16 <br/>128GB*",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Inovação que cabe na sua mão. Com o iPhone 16 128GB*, desempenho e tecnologia de ponta estão sempre ao seu alcance. Um prêmio para quem vive conectado.</span>',
            },
            {
                title: "Smartwatch <br/>Galaxy Watch <br/>Ultra*",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Tecnologia que acompanha seu ritmo. Com o Smartwatch Galaxy Watch Ultra*, você tem saúde, estilo e funcionalidade no pulso. Um prêmio que está sempre com você.</span>',
            },
            {
                title: "S6 Lite*",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Entretenimento e produtividade na ponta dos dedos. Com o S6 Lite*, seu dia rende mais, com mais tela e mais liberdade. Um prêmio que se adapta ao seu ritmo.</span>',
            },
            {
                title: "AirPods 4*",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Som de qualidade onde quer que você vá. Com os AirPods 4*, você curte cada detalhe com conforto e cancelamento de ruído. Um prêmio que ouve você.</span>',
            },
            {
                title: "Smart TV 50” Samsung*",
                typeId: 2,
                type: "Sorteio",
                description: '<span class="description-intro">Imersão total em cada detalhe. Com a Smart TV 50” Samsung*, imagem e som elevam sua experiência a outro nível. Um prêmio para ver e viver.</span>',
            },
        ];
        // Initialize the slider
        function initializeSlider() {
            // Update navigation buttons visibility
            updateButtonStates();
            // Set up initial prize positions
            setupPrizePositions();
        }
        // Set up prize positions
        function setupPrizePositions() {
            // Salvar referência ao card-cta se existir
            const ctaCard = upcomingPrizesContainer.querySelector(".slider-cta-card");
            // Clear containers
            viewedPrizesContainer.innerHTML = "";
            upcomingPrizesContainer.innerHTML = "";
            // Atualiza as informações do prêmio atual
            updatePrizeContent(currentIndex);
            // Recolocar o card-cta no container se ele existia
            if (ctaCard) {
                if (window.matchMedia("(max-width: 768px)").matches) {
                    ctaCard.classList.add("prize-item");
                }
                upcomingPrizesContainer.appendChild(ctaCard);
            }
            // Distribute prizes to appropriate containers
            prizeItems.forEach((item, index) => {
                const prizeClone = item.cloneNode(true);
                if (index < currentIndex) {
                    // Prizes already viewed go to the left container
                    const offset = currentIndex - index;
                    // Removendo os estilos top e left conforme solicitado
                    // Mantendo apenas o zIndex e opacity
                    prizeClone.style.zIndex = `${index}`;
                    if (!window.matchMedia("(max-width: 768px)").matches) {
                        prizeClone.style.opacity = `${0.9 - offset * 0.1}`;
                    }
                    else {
                        prizeClone.style.opacity = `${0}`;
                    }
                    // Removendo a classe active para garantir que apenas o item atual tenha essa classe
                    prizeClone.classList.remove("active");
                    // Garantindo que a imagem mantenha suas proporções originais
                    const img = prizeClone.querySelector("img");
                    if (img) {
                        img.style.maxWidth = "100%";
                        img.style.height = "auto";
                        img.style.objectFit = "contain";
                    }
                    viewedPrizesContainer.appendChild(prizeClone);
                }
                else if (index === currentIndex) {
                    // O prêmio atual é exibido no container esquerdo (como se tivesse acabado de transicionar)
                    const leftClone = prizeClone.cloneNode(true);
                    leftClone.setAttribute("tabindex", "1");
                    leftClone.style.zIndex = "100";
                    // Configurando para animação Smart Animate
                    leftClone.style.opacity = "0"; // Começa invisível para a animação
                    // Adicionando a classe 'active' para a imagem atual
                    leftClone.classList.add("active");
                    // Garantindo que a imagem mantenha o tamanho original (457px)
                    const img = leftClone.querySelector("img");
                    if (img) {
                        if (!window.matchMedia("(max-width: 768px)").matches) {
                            img.style.maxWidth = "457px";
                            img.style.height = "auto";
                            img.style.objectFit = "contain";
                        }
                    }
                    // Adicionando ao DOM
                    viewedPrizesContainer.appendChild(leftClone);
                    // Forçando um reflow para garantir que a animação funcione
                    void leftClone.offsetWidth;
                    // Aplicando a animação
                    leftClone.style.opacity = "1";
                }
                else {
                    // Upcoming prizes go to the right container
                    const offset = index - currentIndex - 1;
                    // Removendo os estilos top e right conforme solicitado
                    // Mantendo apenas o zIndex e opacity
                    prizeClone.style.zIndex = `${totalPrizes - index}`;
                    // Configurando para animação Smart Animate
                    if (offset === 0) {
                        // Primeiro item no container direito (próximo a ser mostrado)
                        prizeClone.style.opacity = "0"; // Começa invisível para a animação
                        prizeClone.classList.add("entering"); // Adiciona classe para animação
                        prizeClone.setAttribute("tabindex", "2");
                    }
                    else {
                        prizeClone.style.opacity = `${0.9 - offset * 0.1}`;
                    }
                    // Garantindo que a imagem mantenha suas proporções originais
                    const img = prizeClone.querySelector("img");
                    if (img) {
                        img.style.maxWidth = "100%";
                        img.style.height = "auto";
                        img.style.objectFit = "contain";
                    }
                    upcomingPrizesContainer.appendChild(prizeClone);
                    // Forçando um reflow para garantir que a animação funcione
                    if (offset === 0) {
                        void prizeClone.offsetWidth;
                        setTimeout(() => {
                            prizeClone.style.opacity = "1";
                        }, 80);
                    }
                }
            });
        }
        // Update prize content based on the current index
        function updatePrizeContent(index) {
            // Obter o container de informações do prêmio
            const prizeInfoContainer = document.querySelector(".prize-info");
            const navigationControls = document.querySelector(".navigation-controls");
            const navigationButtons = navigationControls?.querySelectorAll(".nav-button");
            // Aplicar a classe 'changing' para iniciar a animação de saída
            prizeInfoContainer.classList.add("changing");
            prizeInfoContainer.classList.remove("active");
            // Aguardar um pouco para atualizar o conteúdo após a animação de saída
            setTimeout(() => {
                // Atualizar o conteúdo
                prizeTitle.innerHTML = prizeData[index].title;
                prizeTitle.setAttribute("tabindex", "1");
                if (prizeType.classList[1].startsWith("tipo")) {
                    prizeType.classList.remove(prizeType.classList[1]);
                }
                prizeType.classList.add(`tipo${prizeData[index].typeId}`);
                prizeType.textContent = prizeData[index].type;
                prizeType.setAttribute("tabindex", "1");
                prizeDescription.innerHTML = prizeData[index].description;
                prizeDescription.setAttribute("tabindex", "1");
                navigationButtons?.forEach((button) => {
                    button.setAttribute("tabindex", "2");
                });
                // Forçar um reflow para garantir que a animação funcione
                void prizeInfoContainer.offsetWidth;
                // Aplicar a classe 'active' para iniciar a animação de entrada
                prizeInfoContainer.classList.remove("changing");
                prizeInfoContainer.classList.add("active");
            }, 400); // Metade da duração da animação para uma transição suave
        }
        // Navigate to previous or next slide
        function navigate(direction) {
            // Armazenar o índice anterior para animação
            const previousIndex = currentIndex;
            if (direction === "left" && currentIndex > 0) {
                // Adicionar classe 'leaving' aos itens que estão saindo
                const currentItems = viewedPrizesContainer.querySelectorAll(".prize-item.active");
                currentItems.forEach((item) => {
                    item.classList.remove("active");
                    item.classList.add("leaving");
                    // Remover o item após a animação terminar
                    setTimeout(() => {
                        if (item.parentNode) {
                            item.parentNode.removeChild(item);
                        }
                    }, 800); // Corresponde à duração da animação (800ms)
                });
                currentIndex--;
                setTimeout(() => {
                    setupPrizePositions(); // Isso já chama updatePrizeContent internamente
                }, 400); // Pequeno atraso para a animação de saída começar primeiro
            }
            else if (direction === "right" && currentIndex < totalPrizes - 1) {
                // Adicionar classe 'leaving' aos itens que estão saindo
                const currentItems = viewedPrizesContainer.querySelectorAll(".prize-item.active");
                currentItems.forEach((item) => {
                    item.classList.remove("active");
                    item.classList.add("leaving");
                    // Remover o item após a animação terminar
                    setTimeout(() => {
                        if (item.parentNode) {
                            item.parentNode.removeChild(item);
                        }
                    }, 800); // Corresponde à duração da animação (800ms)
                });
                currentIndex++;
                setTimeout(() => {
                    setupPrizePositions(); // Isso já chama updatePrizeContent internamente
                }, 400); // Pequeno atraso para a animação de saída começar primeiro
            }
            // Update button states
            updateButtonStates();
            setTimeout(() => {
                const assistiveElement = document.createElement("div");
                assistiveElement.classList.add("assistive-message--hidden");
                assistiveElement.setAttribute('aria-live', 'assertive');
                assistiveElement.innerHTML = 'Prêmio mudado';
                viewedPrizesContainer.insertAdjacentElement("afterbegin", assistiveElement);
                setTimeout(() => {
                    const prizeActive = viewedPrizesContainer.querySelector(".prize-item.active");
                    prizeActive?.focus();
                    assistiveElement.remove();
                }, 200);
            }, 1000);
        }
        // Update button states
        function updateButtonStates() {
            const navigationControls = document.querySelector(".navigation-controls");
            const rightContainer = document.getElementById("upcoming-prizes");
            if (!navigationControls) {
                console.error("Elemento .navigation-controls não encontrado!");
                return;
            }
            // Remover todas as classes de estado anteriores
            navigationControls.classList.remove("first-slide", "last-slide", "single-arrow");
            // Controlar a visibilidade do card-cta
            if (currentIndex === totalPrizes - 1) {
                const ctaCard = upcomingPrizesContainer.querySelector(".slider-cta-card");
                // Mostrar o card-cta no último slide
                rightContainer?.classList.add("show-cta");
                ctaCard?.querySelector(".cta-title")?.setAttribute("tabindex", "3");
                ctaCard?.querySelector(".cta-description")?.setAttribute("tabindex", "3");
                ctaCard?.querySelector(".cta-button")?.setAttribute("tabindex", "3");
            }
            else {
                // Ocultar o card-cta em outros slides
                rightContainer?.classList.remove("show-cta");
            }
            if (currentIndex === 0) {
                // Primeiro slide - adicionar classes apropriadas
                navigationControls.classList.add("first-slide");
                navigationControls.classList.add("single-arrow");
                prevButton.style.display = "none"; // Garantindo que o botão anterior esteja oculto
                nextButton.style.display = "flex"; // Garantindo que o botão próximo esteja visível
            }
            else if (currentIndex === totalPrizes - 1) {
                // Último slide - adicionar classes apropriadas
                navigationControls.classList.add("last-slide");
                navigationControls.classList.add("single-arrow");
                prevButton.style.display = "flex"; // Garantindo que o botão anterior esteja visível
                nextButton.style.display = "none"; // Garantindo que o botão próximo esteja oculto
            }
            else {
                // Slides do meio - ambos os botões visíveis
                prevButton.style.display = "flex";
                nextButton.style.display = "flex";
            }
        }
        // Event listeners
        prevButton.addEventListener("click", () => navigate("left"));
        nextButton.addEventListener("click", () => navigate("right"));
        // Keyboard navigation
        document.addEventListener("keydown", (e) => {
            if (e.key === "ArrowLeft") {
                navigate("left");
            }
            else if (e.key === "ArrowRight") {
                navigate("right");
            }
        });
        // Inicializar o slider
        initializeSlider();
    });
}
